// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2uxO8","cell":"ColumnAccessor_cell__1XdMB","firstCellAccent":"ColumnAccessor_firstCellAccent__1exXX"};